import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import Header from "./header"
import Footer from "./footer"
import * as styles from "./layout.module.scss"
import 'bootstrap/dist/css/bootstrap-grid.min.css';
import 'bootstrap/dist/css/bootstrap-utilities.min.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./layout.scss"


const Layout = ({ children }) => {

    const data = useStaticQuery(graphql`
       query SiteTitleQuery {
         site {
           siteMetadata {
             title
           }
         }
       },
     `)
  
    return (
    <main className={styles.main}>
        <Header siteTitle={data.site.siteMetadata.title} />
        <div>
          <main className="main">{children}</main>
        </div>
        <Footer />
    </main>
    )
  }
  
  Layout.propTypes = {
    children: PropTypes.node.isRequired,
  }
  
  export default Layout